import React from 'react';
import { OrganizationProfile, useOrganization } from '@clerk/clerk-react';

export const ClerkOrganizationProfileTab = (/*{ currentTab }: TabProps*/) => {
  const { organization, isLoaded } = useOrganization();
  return (
    <div>
      {
        <style>{`
            .cl-membersPageInviteButton {
              display: none !important;
            }
            .cl-profileSection__organizationDanger {
              display: none !important;
            }
          `}</style>
      }
      {isLoaded && organization ? <OrganizationProfile /> : null}
    </div>
  );
};
